import { Grid2 as Grid } from "@mui/material";
import { useWatch } from "react-hook-form";
import { useTranslate } from "@refinedev/core";

import { Form } from "@shared/components";

export function MessageStep() {
  const translate = useTranslate();
  const type = useWatch({ name: "notification_type" });

  if (type === "push") {
    return (
      <Grid container spacing={2}>
        <Grid size={{ xs: 12 }}>
          <Form.Input
            name="push_subject"
            label={translate("notifications_emails_admin.fields.push_subject")}
            required
          />
        </Grid>
        <Grid size={{ xs: 12 }}>
          <Form.Input
            name="push_body"
            label={translate("notifications_emails_admin.fields.push_body")}
            multiline
            rows={4}
            required
          />
        </Grid>
      </Grid>
    );
  }

  return (
    <Grid container spacing={2}>
      <Grid size={{ xs: 12 }}>
        <Form.Input
          name="email_subject"
          label={translate("notifications_emails_admin.fields.email_subject")}
          required
        />
      </Grid>
      <Grid size={{ xs: 12 }}>
        <Form.Editor
          name="email_body"
          label={translate("notifications_emails_admin.fields.email_body")}
          minHeight={300}
        />
      </Grid>
    </Grid>
  );
}
